import React from 'react'

import { Spacer } from '../global'

const PasswordRules = ({
  uppercaseValid,
  lowercaseValid,
  numberValid,
  specialCharValid,
  lenghtValid,
}: {
  uppercaseValid: boolean
  lowercaseValid: boolean
  numberValid: boolean
  specialCharValid: boolean
  lenghtValid: boolean
}) => {
  return (
    <div
      className={
        uppercaseValid && numberValid && specialCharValid && lowercaseValid
          ? 'valid'
          : 'contentDescriptionPassword'
      }
    >
      <Spacer height={10} />
      <p className="descriptionPassword">La contraseña debe incluir:</p>
      <div className="content-rules">
        <p className={lowercaseValid ? 'rules valid' : 'rules'}>1 minuscula</p>
        <p className={uppercaseValid ? 'rules valid' : 'rules'}>1 mayúscula</p>
        <p className={numberValid ? 'rules valid' : 'rules'}>1 número</p>
        <p className={specialCharValid ? 'rules valid' : 'rules'}>
          1 caracter especial
        </p>
        <p className={lenghtValid ? 'rules valid' : 'rules'}>
          8 caracteres en total
        </p>
      </div>
    </div>
  )
}

export default PasswordRules
